import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { API, graphqlOperation } from "aws-amplify";
import { getOrganization } from "../../../graphql/apnid-queries";

import { Button, ColumnLayout, Spinner } from "@amzn/awsui-components-react";

import { formatListItems, objIsEmpty } from "../../../utils";

const OrganizationDetails = ({ partnerId, history }) => {
  const currentUser = useSelector(state => state.app.currentUser);
  const isExecSponsor =
    currentUser.groups.indexOf("PartnerExecutiveSponsor") > -1 ? true : false;

  const [loading, setLoading] = useState(false);
  const [partnerDetail, setPartnerDetail] = useState(false);

  // Get data on page load
  useEffect(() => {
    fetchData();
  }, []); // eslint-disable-line

  // Fetch data from GraphQL API
  const fetchData = async () => {
    setLoading(true);
    const result = await API.graphql(
      graphqlOperation(getOrganization, { id: partnerId })
    );
    let detail = result.data.getPartner;
    if (!detail.headquarters) detail.headquarters = "";
    if (!detail.coverageAreas) detail.coverageAreas = [];
    if (!detail.specialtyDomains) detail.specialtyDomains = [];
    setPartnerDetail(detail);
    setLoading(false);
  };

  return (
    <>
      <div className="awsui-util-container">
        <div className="awsui-util-container-header">
          <div className="awsui-util-action-stripe">
            <div className="awsui-util-action-stripe-title">
              <h2>Organization Details</h2>
            </div>
            {!loading && isExecSponsor && (
              <div className="awsui-util-action-stripe-group">
                <Button
                  icon="edit"
                  onClick={() => history.push(`/organization/edit`)}
                >
                  Edit
                </Button>
              </div>
            )}
          </div>
        </div>
        {loading && (
          <div>
            <span className="awsui-util-status-inactive">
              <Spinner /> Loading
            </span>
          </div>
        )}
        {!loading && !objIsEmpty(partnerDetail) && (
          <ColumnLayout columns={4} variant="text-grid">
            <div data-awsui-column-layout-root="true">
              <div>
                <div className="awsui-util-spacing-v-s">
                  <div>
                    <div className="awsui-util-label">Organization Name</div>
                    <div>{partnerDetail.name}</div>
                  </div>
                  <div>
                    <div className="awsui-util-label">
                      Headquarters Location
                    </div>
                    <div>{partnerDetail.headquarters}</div>
                  </div>
                  <div>
                    <div className="awsui-util-label">Partner Geo</div>
                    <div>{partnerDetail.geo}</div>
                  </div>
                </div>
              </div>
              <div>
                <div className="awsui-util-spacing-v-s">
                  <div>
                    <div className="awsui-util-label">Email Domains</div>
                    <div>
                      {partnerDetail.emailDomain.length
                        ? partnerDetail.emailDomain.map(formatListItems)
                        : "-"}
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="awsui-util-spacing-v-s">
                  <div>
                    <div className="awsui-util-label">Coverage Areas</div>
                    <div>
                      {partnerDetail.coverageAreas.length
                        ? partnerDetail.coverageAreas.map(formatListItems)
                        : "-"}
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="awsui-util-spacing-v-s">
                  <div>
                    <div className="awsui-util-label">Specialty Domains</div>
                    <div>
                      {partnerDetail.specialtyDomains.length
                        ? partnerDetail.specialtyDomains.map(formatListItems)
                        : "-"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ColumnLayout>
        )}
      </div>
    </>
  );
};

export default OrganizationDetails;
